/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import Styled from './style';

const HardwareInstallation = ({}) => {
  return (
    <Styled.Wrapper>
      <div className="welcomeText">
        <h1 className="stepTitle">Device Pairing</h1>
        <div className="iframeWrapper">
          <iframe
            src="https://www.youtube.com/embed/FOw1Ggc393s"
            title="hardware-installation"
            className="respIframe"
          ></iframe>
        </div>
        <div className="details">
          This video will show you exactly how to pair your device. You can find
          this video on{' '}
          <a
            className="linkColor"
            href="https://www.youtube.com/embed/FOw1Ggc393s"
          >
            YouTube
          </a>
          , or you can simply select “Share Video” at the bottom of the page and
          send yourself an email with the link. To move to the next page, select
          “Next.”
        </div>
      </div>
    </Styled.Wrapper>
  );
};

export default HardwareInstallation;

HardwareInstallation.propTypes = {
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired
};
